import React from 'react';
import styled from 'styled-components';

import Button from '../../../../../../CoreWrappers/Button';

const prop = 'actions';

export default (labels, tab) => ({
	id: `${prop}Column`,
	label: labels[prop],
	propName: prop,
	width: 'var(--px-200)',
	customCell: ({riskId}) => {
		const props = {
			label: tab.actionColumnButtonLabel,
			title: tab.actionColumnButtonLabel,
			variant: 'text-alt',
			onClick: () => tab.action(riskId)
		};

		return <StyledButton {...props} />;
	},
});

const StyledButton = styled(Button)`
	min-width: 0;
`;
